export default __webpack_public_path__ + "static/media/spell5.d450bce5.jpg";